import Text, { TEXT_VARIANT } from '@pixum/text';
import { REGEX_CONDITIONS } from '../../../../constants';
import { Placeholder, type PlaceholderProps } from '../../../placeholder';
import type { FooterProps } from '../../types';
import './styles.css';

export function PriceHint({ constants, priceInfo }: FooterProps) {
  const placeholderProps: PlaceholderProps = {
    placeholderContent: constants.i18n_section_footer_note,
    contentToReplaceWith: priceInfo?.title || '',
    regex: REGEX_CONDITIONS.PLACEHOLDER_BRACKET,
    href: priceInfo?.url || '',
  };
  const placeholder = <Placeholder {...placeholderProps} />;

  return (
    <section className="footer__price-hint-section" id="price-hint">
      <Text className="footer__price-hint-text" variant={TEXT_VARIANT.CAPTION}>
        {placeholder}
      </Text>
    </section>
  );
}
